import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {CommonResponse} from '../interfaces/home';

@Injectable({
  providedIn: 'root'
})
export class SbuQuoteServiceProportionService {
  constructor(private http: HttpClient) { }
  baseUrl = environment.baseUrl + 'SBUQuoteServiceProportion/';
  allSBUQuoteServiceProportion(): Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl);
  }
  getSBUQuoteServiceProportion(id: any):Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl +id);
  }
  post(data: any){
    return this.http.post(this.baseUrl, data);
  }
  deleteSBUQuoteServiceProportion(id: any){
    return this.http.delete(this.baseUrl +id);
  }
  updateSBUQuoteServiceProportion(id: any, data: any){
    return this.http.put(this.baseUrl +id, data);
  }
}
